
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.738 7.942a.83.83 0 01-.589-.244L.614 4.162a.833.833 0 111.178-1.179L4.738 5.93 10.042.627a.834.834 0 011.179 1.178L5.328 7.698a.83.83 0 01-.59.244z","fill":"#3DB11D"}})])
          )
        }
      }
    